import React from "react"
import { Layout } from "../layouts/layout"
import {
  GeneralPageComponentProps,
  Team,
  TransparenzProfilFrontmatterDataType,
} from "../../types"
import { turnMdToHtml } from "../../utils"
import { PersonContactInfo } from "../general/PersonContactInfo"
import { HeroSectionTransparenz } from "../layouts/HeroSectionTransparenz"
import { PersonCalendarCard } from "../general/PersonCalendarCard"
import { CallToAction } from "../layouts/CallToAction"
import { useIsMobile } from "../../utils/use-is-mobile"
import { StyledPersonCalendarCard } from "../general/StyledPersonCalendarCard"

export const TransparenzProfilComponent = ({
  data,
  nodes,
}: GeneralPageComponentProps<TransparenzProfilFrontmatterDataType> & Team) => {
  const contactPerson = nodes.find((member) =>
    member.frontmatter.de.name
      .toLowerCase()
      .includes(data.contact.toLowerCase())
  )?.frontmatter.de

  const isMobile = useIsMobile()

  return (
    <Layout pathname={""} english={""} german={""}>
      <HeroSectionTransparenz
        h1={data.title}
        type={data.type}
        onApplyClick={() => console.log("test")}
        gender={data.gender}
      />
      <div
        className={
          "flex sm:flex-row flex-col gap-x-12 my-24 px-4 sm:px-6 max-w-7xl mx-auto stelle mb-0"
        }
      >
        <div
          className="mb-2 prose prose-a:text-green prose-h2:mb-[24px] prose-h2:mt-[18px] prose-h2:max-w-[46ch] prose-h2:text-[32px] prose-h2:font-semibold prose-h2:font-serif text-[18px] font-light leading-[1.54] max-w-[730px] prose-a:no-underline stelle"
          dangerouslySetInnerHTML={{
            __html: turnMdToHtml(data.content),
          }}
        />
        {contactPerson && !isMobile && (
          <div className={"mt-8 md:mt-0"}>
            <PersonContactInfo {...contactPerson} />
          </div>
        )}
      </div>
      <div
        className={"gap-x-12 my-24 px-4 sm:px-6 max-w-7xl mx-auto stelle mt-4 "}
      >
        {contactPerson && isMobile && (
          <StyledPersonCalendarCard
            {...contactPerson}
            background={"lightgray"}
          />
        )}
        {contactPerson && !isMobile && (
          <PersonCalendarCard {...contactPerson} />
        )}
      </div>
      <CallToAction
        h2={
          "Headhunting für HR-Positionen – Sie suchen einen HR-Manager in Festanstellung?"
        }
        description={
          "Profitieren Sie von unserem Pool, der mehr als 8.000 Personalprofis umfasst. Wir repräsentieren Sie überzeugend gegenüber Kandidaten und liefern Ihnen aufgrund unserer einmaligen Expertise ausgezeichnete Ergebnisse."
        }
        button={{
          text: "Jetzt Headhunting ansehen",
          link: "/hr-services-personalexperten/personalberatung-hr/",
        }}
        maxWidthH2={150}
        color={"red"}
      />
    </Layout>
  )
}
